import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: palette['grey-50'],
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
  },
  logo: {
    marginTop: anatomy['space-20'],
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: anatomy['space-24'],
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'space-between',
    padding: `${anatomy['space-24']} ${anatomy['space-20']}`,
    margin: `${anatomy['space-20']} ${anatomy['space-16']}`,
    backgroundColor: palette['greyWhite'],
    borderRadius: anatomy.borderRadiusXl,
    flexGrow: 1,
  },
  eventInfo: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
  },
  label: {
    color: palette['grey-500'],
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
  },
  eventName: {
    fontFamily: fonts.din2014Demi,
    color: palette['grey-950'],
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
  },
  categories: {
    marginTop: anatomy['space-24'],
  },
  qrCode: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
    alignItems: 'center',
    maxWidth: '170px',
    ':not(#__unused__) svg': {
      height: '130px',
      width: '130px',
    },
  },
  qrCodeDrawer: {
    maxWidth: '244px',
    margin: '0 auto',
    ':not(#__unused__) svg': {
      height: '244px',
      width: '244px',
    },
    ':not(#__unused__) > div': {
      height: '244px',
    },
  },
  qrDescription: {
    color: palette['grey-500'],
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: typography['lineHeightCaption-2'],
  },
  allGuestsButton: {
    display: 'flex',
    alignItems: 'center',
    gap: anatomy['space-8'],
    whiteSpace: 'nowrap',
  },
  guests: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: anatomy['space-20'],
    maxHeight: '60vh',
  },
  mainGuest: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-12'],
    color: palette['grey-950'],
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
  },
  mainGuestAlone: {
    gap: anatomy['space-4'],
  },
  divider: {
    width: '164px',
    height: '1px',
    margin: anatomy['space-4'],
    background: palette['darked-10'],
  },

  additionalGuests: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-12'],
  },
  guestsList: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-8'],
    color: palette['grey-950'],
    fontSize: typography['fontSizeBody-5'],
    lineHeight: typography['lineHeightCaption-1'],
  },
});
